import React, { useEffect, useState, useRef } from "react";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
  deleteDoc,
  query,
  orderBy
} from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ReactMarkdown from "react-markdown";
import TurndownService from "turndown";
import "./index.css";

const turndownService = new TurndownService();

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["clean"],
  ],
};

const formats = [
  "header", "bold", "italic", "underline", "list", "bullet", "link", "image"
];

function Premios() {
  const [premiosData, setPremiosData] = useState([]);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [descricaoHtml, setDescricaoHtml] = useState("");
  const [juri, setJuri] = useState("");
  const [premiados, setPremiados] = useState("");
  const [ordem, setOrdem] = useState(0);
  const [newBanner, setNewBanner] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [search, setSearch] = useState("");
  const fileRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(collection(db, "evento_premios"), orderBy("ordem", "asc"));
        const snapshot = await getDocs(q);
        setPremiosData(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch {
        setError("Erro ao sincronizar os dados dos prémios.");
      }
    };
    fetchData();
  }, []);

  const startEditing = (item) => {
    setSelected(item);
    setTitulo(item.titulo || "");
    setDescricaoHtml(item.descricao || "");
    setJuri(item.juri || "");
    setPremiados(item.premiados || "");
    setOrdem(item.ordem ?? 0);
    setBannerPreview(item.banner || null);
    setNewBanner(null);
  };

  const savePremio = async () => {
    if (!selected) return;

    let bannerURL = selected.banner || "";

    if (newBanner) {
      const bannerRef = ref(storage, `evento_premios/${newBanner.name}`);
      await uploadBytes(bannerRef, newBanner);
      bannerURL = await getDownloadURL(bannerRef);
      setBannerPreview(bannerURL);
    }

    const descricaoMarkdown = turndownService.turndown(descricaoHtml);
    const juriMarkdown = turndownService.turndown(juri);
    const premiadosMarkdown = turndownService.turndown(premiados);

    const docRef = doc(db, "evento_premios", selected.id);
    await updateDoc(docRef, {
      titulo,
      descricao: descricaoMarkdown,
      juri: juriMarkdown,
      premiados: premiadosMarkdown,
      ordem: Number(ordem),
      banner: bannerURL,
    });

    setPremiosData(prev =>
      prev.map(d =>
        d.id === selected.id
          ? { ...d, titulo, descricao: descricaoMarkdown, juri: juriMarkdown, premiados: premiadosMarkdown, ordem: Number(ordem), banner: bannerURL }
          : d
      )
    );

    setSelected(prev => ({
      ...prev,
      titulo,
      descricao: descricaoMarkdown,
      juri: juriMarkdown,
      premiados: premiadosMarkdown,
      ordem: Number(ordem),
      banner: bannerURL
    }));

    setNewBanner(null);
  };

  const deletePremio = async (id) => {
    if (!window.confirm("Tem certeza que deseja apagar este prémio?")) return;
    await deleteDoc(doc(db, "evento_premios", id));
    setPremiosData(prev => prev.filter(d => d.id !== id));
    if (selected?.id === id) setSelected(null);
  };

  const addPremio = async () => {
    const newItem = {
      titulo: "",
      descricao: "",
      juri: "",
      premiados: "",
      ordem: 0,
      banner: "",
      created_time: new Date(),
    };
    const docRef = await addDoc(collection(db, "evento_premios"), newItem);
    const itemWithId = { ...newItem, id: docRef.id };
    startEditing(itemWithId);
    setPremiosData(prev => [itemWithId, ...prev]);
  };

  if (error) return <p>{error}</p>;

  const filteredData = premiosData.filter(item =>
    item.titulo?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="table-container">
      <div className="filtros">
        <input
          type="text"
          placeholder="Pesquisar por título"
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="input"
        />
        <button className="btn btn-add" onClick={addPremio}>
          Novo Prémio
        </button>
      </div>

      <div>
        {filteredData.length === 0 ? (
          <p style={{ textAlign: "center", color: "#6b7280" }}>Sem prémios</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Banner</th>
                <th>Título</th>
                <th>Júri</th>
                <th>Premiados</th>
                <th>Ordem</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map(item => (
                <tr key={item.id}>
                  <td>
                    {item.banner ? (
                      <img
                        src={item.banner}
                        alt="banner"
                        style={{ width: "80px", height: "50px", objectFit: "cover", borderRadius: "6px" }}
                      />
                    ) : "—"}
                  </td>
                  <td>{item.titulo || "—"}</td>
                  <td><ReactMarkdown>{item.juri}</ReactMarkdown></td>
                  <td><ReactMarkdown>{item.premiados}</ReactMarkdown></td>
                  <td>{item.ordem ?? "—"}</td>
                  <td>
                    <button className="btn btn-add" onClick={() => startEditing(item)}>
                      Abrir
                    </button>

                    <button className="btn btn-delete" onClick={() => deletePremio(item.id)}>
                      Apagar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="drawer">

          <div className="drawer-content">

            <label>Título:</label>
            <input type="text" value={titulo} onChange={e => setTitulo(e.target.value)} />

            <br /><br />

            <label>Ordem:</label>
            <input type="number" value={ordem} onChange={e => setOrdem(Number(e.target.value))} />

            <br /><br />

            <label>Júri:</label>
            <ReactQuill
              theme="snow"
              value={juri}
              onChange={setJuri}
              modules={modules}
              formats={formats}
              style={{ height: "80px", marginBottom: "50px" }}
            />

            <label>Premiados:</label>
            <ReactQuill
              theme="snow"
              value={premiados}
              onChange={setPremiados}
              modules={modules}
              formats={formats}
              style={{ height: "200px", marginBottom: "50px" }}
            />

            <label>Descrição:</label>
            <ReactQuill
              theme="snow"
              value={descricaoHtml}
              onChange={setDescricaoHtml}
              modules={modules}
              formats={formats}
              style={{ height: "80px", marginBottom: "50px" }}
            />

            <br /><br />

            <label>Banner:</label>
            {bannerPreview && (
              <img
                src={bannerPreview}
                alt="Banner Preview"
                className="banner-noticia"
                style={{ marginBottom: "50px" }}
              />
            )}

            <input
              type="file"
              ref={fileRef}
              accept="image/*"
              onChange={e => {
                const file = e.target.files[0];
                setNewBanner(file);
                setBannerPreview(file ? URL.createObjectURL(file) : null);
              }}
            />

          </div>

          <div className="drawer-footer">
            <button className="btn btn-add" onClick={savePremio}>
              Guardar
            </button>

            <button className="btn btn-cancel" onClick={() => setSelected(null)}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Premios;
